export default "__VITE_ASSET__BH$uyg8Z__"